import { ITagCategory } from '@models/TagCategory.model';
import set from 'just-safe-set';
import { IFilterTagData, SelectedMap } from './types';

export function matchesTags(category: ITagCategory, searchText: string) {
  const tagSubset = Number(category.tags?.length) < Number(category?.tagsCount);
  const categoryMatch = category.name
    .toLowerCase()
    .includes(searchText.toLowerCase());
  return tagSubset || !categoryMatch;
}

export function groupSelectedTags(selectedTags: IFilterTagData[]) {
  const groupedTags = selectedTags.reduce((acc, current) => {
    set(acc, `${current.tagCategoryId}.${current.id}`, current);
    return acc;
  }, {} as SelectedMap);

  // Make the result a map
  const mapEntries = Object.entries(groupedTags).map(categoryEntry => {
    const [categoryId, categoryMap] = categoryEntry;
    return [categoryId, new Map(Object.entries(categoryMap))] as const;
  });
  const groupedTagsAsMap = new Map(mapEntries);

  return groupedTagsAsMap;
}
